/* eslint-disable react/prop-types */
import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { observer } from "mobx-react";
import Trash from '../svg/Trash';
import studioStore from '@/stores/studioStore';

const QuantityIndicator = observer(({
  inCart,
  handleClearFromCart,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const clearFromCart = () => {
    handleClearFromCart();
    setTimeout(() => {
      setIsHovered(false);
    }, 500);
  }

  return (
    <AnimatePresence initial mode="wait">
      {inCart > 0 && (
        <motion.div
          key="quantity-indicator"
          className="quantity-indicator h-8 w-8 p-1 text-center rounded-full text-white flex items-center justify-center cursor-pointer"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          exit={{ scale: 0 }}
          transition={{ duration: 0.2 }}
          style={{ backgroundColor: studioStore?.settings?.colors?.primary_color }}
          whileHover={{
            backgroundColor: studioStore?.settings?.colors?.error_color,
          }}
          onClick={clearFromCart}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {/* Conditional rendering based on hover state */}
          {isHovered ? (
            // Show Trash icon when hovered
            <motion.div
              key="trash-icon"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.1 }}
              className="absolute"
            >
              <Trash stroke="#FFFFFF" size="16" />
            </motion.div>
          ) : (
            // Show inCart quantity when not hovered
            <motion.div
              key="content"
              initial={{ opacity: 1 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.1 }}
            >
              {inCart}
            </motion.div>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
});

export default QuantityIndicator;
